import { render, staticRenderFns } from "./CustomerDetailSummary.vue?vue&type=template&id=6bf7cb00&scoped=true"
import script from "./CustomerDetailSummary.vue?vue&type=script&lang=js"
export * from "./CustomerDetailSummary.vue?vue&type=script&lang=js"
import style0 from "./CustomerDetailSummary.vue?vue&type=style&index=0&id=6bf7cb00&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf7cb00",
  null
  
)

export default component.exports